import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=27bab2a3&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=27bab2a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bab2a3",
  null
  
)

export default component.exports